export class BrandManagementRequest
{
	name?: string | null
	companyName?: string | null
	products?: string[] | null
	minActiveContracts?: number | null
	maxActiveContracts?: number | null
	pageSize?: number | null
	pageId?: number | null
	orderBy?: string | null
	orderType?: string | null
}
